export const REGEX_EMAIL = /^[a-zA-Z0-9._%+-]+@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)(?:\.(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?))*\.[a-zA-Z]{2,}$/;
export const REGEX_ID = /^50[\da-zA-Z]*$/
export const REGEX_EMAIL_LATIN_LANGUAGE = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
export const REGEX_PASSWORD_LENGTH = /^.{10,32}$/
export const REGEX_PASSWORD_FORMAT = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9])/
export const SCREEN_WIDTH = {
  ipadMiniHorSmall: 768,
  ipadMiniHor: 820,
  ipad6: 1200,
  ipadMini: 1200, // when in ipad mode, it will auto shrink left menu only show icon
};

export const STATUS = {
  success: 'success',
  failed: 'failed'
}

export const USER_STATUS = {
  FullAccess: 1,
  Provisional: 0,
}

export const RESPONSE_ERR = {
  E0101: "E0101",
  E0102: "E0102",
  E0103: "E0103",
  E0104: "E0104",
  E0105: "E0105",
  E0106: "E0106",
  E0501: "E0501",
  E0901: "E0901",
  E0902: "E0902",
  E0502: "E0502",
  WAS001: "WAS001",
  WAS002: "WAS002",
  WAS003: "WAS003",
  WAI005: "WAI005",
  WAI006: "WAI006",
  WAI001: "WAI001",
  WAI002: "WAI002",
  WAI003: "WAI003",
  WAI007: "WAI007",
  WAI008: "WAI008",
  WAI009: "WAI009",
}

export const RESPONSE_MESSAGE = {
  E0101_MESSAGE: "ID / Password invalid",
  E0102_MESSAGE: "User not register",
  E0103_MESSAGE: "User has expired",
  E0104_MESSAGE: "User has not changed password for the first time",
  E0105_MESSAGE: "User is in reset password state",
  CHANGE_PASSWORD_LENGTH_VALIDATION: "The password must be at least 10 characters and no more than 32 characters",
}

export const ERR_MESSAGE = {
  WAI001_MESSAGE: "入力されたIDまたパスワードに誤りがあります。",
  WAI002_MESSAGE: "入力されたIDは現在無効となっております。",
  WAI003_MESSAGE: "メールアドレスもしくはID誤りがあります。入力しなおしてください",
  WAI006_MESSAGE: "仮登録状態では、パスワードリセットはできません。ログインから本登録へお進みください。",
  WAS001_MESSAGE: "データを取得できません",
  WAS002_MESSAGE: "データを更新できません",
  WAS003_MESSAGE: "データを登録できません",
  E0102_MESSAGE: "User not register",
  E0103_MESSAGE: "User has expired",
  E0104_MESSAGE: "User has not changed password for the first time",
  E0105_MESSAGE: "User is in reset password state",
  E0501_MESSAGE: "現在のパスワードと違います",
  WAI005_MESSAGE: "パスワードの入力を複数回間違えたため、IDが一時的にロックされました。しばらく時間をおいてから再度お試しください。",
  SYSTEM_ERROR_MESSAGE: "エラーが発生しました。後でもう一度お試しください。",
  CHANGE_PASSWORD_LENGTH_VALIDATION_ERROR: "変更前のパスワード現在のパスワードと違います",
  MESSAGE_ERROR_SETTING_PLACE_OTHER_REQUIRE: "指定納品場所（その他）が入力必須",
  MESSAGE_ERROR_CHARACTOR_MAX_SETTING_PLACE: "回収場所は25文字以内で入力してください",
  MESSAGE_ERROR_CHARACTOR_MAX_DELIVERY_PLACE: "納品場所は25文字以内で入力してください",
  MESSAGE_ERROR_DELIVERY_LOCATION_REQUIRE: "指定納品場所を選択してください",
  MESSAGE_ERROR_EMPTY_CONTAINER_FLAG: "空容器の回収を選択してください",
  MESSAGE_ERROR_VALID_FROM_DATE_REQUIRE: "電子伝票設定有効開始日が入力必須",
  MESSAGE_ERROR_RECOVERY_FLAG: "空容器の回収場所を選択してください",
  MESSAGE_ERROR_VALID_FROM_DATE: "電子伝票設定変更の有効開始日は４日以降で指定してください",
  MESSAGE_ERROR_DOOR_VALID_FROM_DATE_REQUIRE: "置き配有効開始日が入力必須",
  MESSAGE_ERROR_DOOR_VALID_FROM_DATE: "選択できない日付です。有効な日付をカレンダーから選択してください",
  MESSAGE_ERROR_EMPTY_CONTAINER_IS_REQUIRE: "空容器の回収場所（その他）が入力必須",
  MESSAGE_ERROR_VALIDATE_EMAIL_REGEX: "メールアドレスの形式に誤りがあります。再度ご確認ください。",
  MESSAGE_ERROR_DOOR_STEP_DELIVERY_PHOTO: "置き配画像配信区分を選択してください",
  MESSAGE_ERROR_NO_CHANGE_SETTING: "設定の変更がない場合、次のページに進めません。",
  MESSAGE_ERROR_CONFIRM_EMAIL_DIFF_NEW_EMAIL : "入力されたメールアドレスが一致しません。再度確認してください。",
  MESSAGE_ERROR_NEW_MAIL_DIFF_ORIGIN_MAIL: "変更後のメールアドレスは変更前のメールアドレスと違う値を入力してください" ,
  MESSAGE_ERROR_NEW_EMAIL_IS_REQUIRE_SCN10: "変更後のメールアドレスが入力必須",
  MESSAGE_ERROR_CONFIRM_EMAIL_IS_REQUIRE_SCN10: "変更後のメールアドレス（確認）が入力必須",

}

export const COMPANY_CODE = {
  FVJ: '0803',
  CCBJI: '0801'
}
